<!--帮助文档-->
<template>
  <div class="apps-content">
    <div style="otherInfo">
      <div class="infoTopBox" :style="infoTopBox">
        <div class="infoTopBoxdiv">
          <div class="topMenu">
            <div class="leftitem">
              <div :style="logoStyle"></div>
              <div class="supgate">{{logo.protal}}</div>
            </div>
            <div class="rightitem">
              <div class="otherinfo">
                <div class="name">
                  <span>{{helpdocument}}</span>
                  <span>{{friendshiplink}}</span>
                  <span>{{aboutus}}</span>
                </div>
                <div class="infoshow">
                  <div class="info-content">
                    <a
                      href="#"
                      @click="jumpTos(infohelpItemData.noticeId)"
                      v-for="infohelpItemData in infohelpItemDatas"
                      :key="infohelpItemData.key"
                    >
                      <span :title="infohelpItemData.name">{{infohelpItemData.name}}</span>
                    </a>
                  </div>
                  <div class="info-content">
                    <a
                      href="#"
                      @click="showlink(infolinkItemData.url)"
                      v-for="infolinkItemData in infolinkItemDatas"
                      :key="infolinkItemData.key"
                    >
                      <span :title="infolinkItemData.name">{{infolinkItemData.name}}</span>
                    </a>
                  </div>
                  <div class="info-content">
                    <a
                      href="#"
                      @click="showzbout(infoaboutItemData.url)"
                      v-for="infoaboutItemData in infoaboutItemDatas"
                      :key="infoaboutItemData.key"
                    >
                      <span :title="infoaboutItemData.name">{{infoaboutItemData.name}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="infoBottomBox" :style="infoBottomBox">
        <div class="infodiv">
          <div class="suplogo">
            <div :style="logoStyle"></div>
          </div>
          <div class="kingdeeinfo" :style="kingdeeinfo">{{enterprise.introduce}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "./Logo.vue";
import { mapGetters } from "vuex";
import axios from "@/utils/http"; // 导入http中创建的axios实例
export default {
  components: {
    logo: Logo
  },
  data() {
    //常量
    // let constant = JSON.parse(this.$supMainPageConfig).constant;
    // let topboxConfig = this.$supMainPageConfig.topbox;
    // this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    return {
      // helpdocument: constant.helpdocument,
      // friendshiplink: constant.friendshiplink,
      // aboutus: constant.aboutus,
      topBox: {
        display: "flex",
        justifyContent: ["stretch", "center"]
      },
      // infohelpItemDatas: JSON.parse(this.$supMainPageConfig).bottombox.help,
      // infolinkItemDatas: JSON.parse(this.$supMainPageConfig).bottombox.link,
      // infoaboutItemDatas: JSON.parse(this.$supMainPageConfig).bottombox.about,
      // enterprise: JSON.parse(this.$supMainPageConfig).bottombox.enterprise,
      // logo: JSON.parse(this.$supMainPageConfig).logo,
      // showT: this.theme,
      isActive: false
    };
  },
  methods: {
    jumpTos(noticeId) {
      let param = "";
      param = "&noticeId=" + noticeId;
      const base = axios.defaults.baseURL;
      let url = base + "/index.html?formId=srm_srmhelp_query" + param;
      window.open(url, "_blank");
    },
    showlink(showurl) {
      window.open(showurl, "_blank");
    },
    showzbout(showurl) {
      window.open(showurl, "_blank");
    }
  },
  computed: {
    //store里面取数据
    ...mapGetters(["supMainPageConfig"]),
    helpdocument: function() {
      return JSON.parse(this.supMainPageConfig).constant.helpdocument;
    },
    friendshiplink: function() {
      return JSON.parse(this.supMainPageConfig).constant.friendshiplink;
    },
    aboutus: function() {
      return JSON.parse(this.supMainPageConfig).constant.aboutus;
    },
    infohelpItemDatas: function() {
      return JSON.parse(this.supMainPageConfig).bottombox.help;
    },
    infolinkItemDatas: function() {
      return JSON.parse(this.supMainPageConfig).bottombox.link;
    },
    infoaboutItemDatas: function() {
      return JSON.parse(this.supMainPageConfig).bottombox.about;
    },
    enterprise: function() {
      return JSON.parse(this.supMainPageConfig).bottombox.enterprise;
    },

    logo: function() {
      return JSON.parse(this.supMainPageConfig).logo;
    },
    showT: function() {
      return JSON.parse(this.supMainPageConfig).catItemImg.info7.theme;
    },

    logoStyle: function() {
      let logoConfig = JSON.parse(this.supMainPageConfig).logo.imgUrl;
      return {
        backgroundImage: "url(" + logoConfig + ")",
        backgroundRepeat: "round",
        height: "41px",
        width: "124px"
      };
    },
    infoTopBox: function() {
      if (this.showT == 1) {
        return {
          background: "#5582F3",
          display: "flex",
          marginTop: "150px",
          height: "350px",
          width: "100%"
        };
      }
      if (this.showT == 2) {
        return {
          background: "#6869FB",
          display: "flex",
          marginTop: "150px",
          height: "350px",
          width: "100%"
        };
      }
      if (this.showT == 3) {
        return {
          background: "#29C392",
          display: "flex",
          marginTop: "150px",
          height: "350px",
          width: "100%"
        };
      }
      if (this.showT == 4) {
        return {
          background: "#FC8555",
          display: "flex",
          marginTop: "150px",
          height: "350px",
          width: "100%"
        };
      }
    },
    infoBottomBox: function() {
      if (this.showT == 1) {
        return {
          background: "#5582F3",
          height: "100px",
          borderTop: "1px solid #ffffff",
          display: "flex",
          flexDirection: "row"
        };
      }
      if (this.showT == 2) {
        return {
          background: "#6869FB",
          height: "100px",
          borderTop: "1px solid #ffffff",
          display: "flex",
          flexDirection: "row"
        };
      }
      if (this.showT == 3) {
        return {
          background: "#29C392",
          height: "100px",
          borderTop: "1px solid #ffffff",
          display: "flex",
          flexDirection: "row"
        };
      }
      if (this.showT == 4) {
        return {
          background: "#FC8555",
          height: "100px",
          borderTop: "1px solid #ffffff",
          display: "flex",
          flexDirection: "row"
        };
      }
    },
    help: function() {
      if (this.showT == 1) {
        return {
          color: "#ffffff",
          fontSize: "13px",
          marginLeft: "20px",
          marginTop: "10px",
          width: "120px",
          alignItems: "center",
          opacity: "0.7",
          textDecoration: "none"
        };
      }
      if (this.showT == 2) {
        return {
          color: "#ffffff",
          fontSize: "13px",
          marginLeft: "20px",
          marginTop: "10px",
          width: "120px",
          alignItems: "center",
          opacity: "0.7",
          textDecoration: "none"
        };
      }
      if (this.showT == 3) {
        return {
          color: "#ffffff",
          fontSize: "13px",
          marginLeft: "20px",
          marginTop: "10px",
          width: "120px",
          alignItems: "center",
          opacity: "0.7",
          textDecoration: "none"
        };
      }
      if (this.showT == 4) {
        return {
          color: "#ffffff",
          fontSize: "13px",
          marginLeft: "20px",
          marginTop: "10px",
          width: "120px",
          alignItems: "center",
          opacity: "0.7",
          textDecoration: "none"
        };
      }
    },
    kingdeeinfo: function() {
      if (this.showT == 1) {
        return {
          color: "#ffffff",
          marginLeft: "20px",
          marginTop: "35px",
          height: "19px",
          width: "511px",
          fontSize: "14px",
          opacity: "0.7"
        };
      }
      if (this.showT == 2) {
        return {
          color: "#ffffff",
          marginLeft: "20px",
          marginTop: "35px",
          height: "19px",
          width: "511px",
          fontSize: "14px",
          opacity: "0.7"
        };
      }
      if (this.showT == 3) {
        return {
          color: "#ffffff",
          marginLeft: "20px",
          marginTop: "35px",
          height: "19px",
          width: "511px",
          fontSize: "14px",
          opacity: "0.7"
        };
      }
      if (this.showT == 4) {
        return {
          color: "#ffffff",
          marginLeft: "20px",
          marginTop: "35px",
          height: "19px",
          width: "511px",
          fontSize: "14px",
          opacity: "0.7"
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
.infodiv {
  width: 646px;
  margin: 0 auto;
  display: flex;
}
.infoTopBoxdiv {
  width: 1200px;
  margin: 0 auto;
}
.apps-content {
  width: 100%;
  margin: 0px auto;
}
.infoBottomBox .suplogo {
  margin-top: 23px;
  height: 39px;
  width: 114px;
  opacity: 0.7;
}

.topMenu {
  display: flex;
  flex-direction: row;
  height: 60px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
.topMenu .leftitem {
  display: flex;
  flex-direction: row;
  width: 300px;
  height: 250px;
  margin-top: 260px;
}

.otherinfo {
  width: 600px;
  height: 40px;
  display: flex;
  flex-direction: column;
}
.rightitem {
  display: flex;
  margin-top: 60px;
  width: 500px;
  align-items: center;
}
.rightitem .otherinfo .infoshow {
  display: flex;
}
.rightitem .otherinfo .infoshow .info-content {
  flex: 1;
  margin-top: 10px;
  height: 250px;
  display: flex;
  flex-direction: column;
}

#toTop {
  background-color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
  margin-left: 500px;
  margin-top: 30px;
}

.name {
  width: 500px;
  display: flex
}
.name span{
  flex:1;
  size: 16px;
  margin-left: 20px;
  width: 60px;
  font-weight: 400;
  line-height: 22px;
  align-items: center;
  color: #ffffff;
}

.info-content a {
  color: #ffffff;
  font-size: 13px;
  margin-left: 20px;
  margin-top: 10px;
  width: 115px;
  align-items: center;
  opacity: 0.7;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.supgate {
  height: 22px;
  width: 70px;
  margin-left: 10px;
  margin-top: 12px;
  font-size: 14px;
  color: #ffffff;
  width: 112px;
}
</style>
